"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  "button.delete": "Excluir",
  "button.download": "Baixar",
  "button.close": "Fechar",
  "button.submit": "Enviar",
  "button.help": "Ajuda",
  "button.rotate": "Girar",
  "button.bookmarks": "Marcações",
  "button.print": "Imprimir",
  "preview.notAvailable": "Visualização não disponível para este tipo de arquivo.",
  "preview.passwordRequired": "Senha solicitada",
  "preview.passwordDesc": "Digite uma senha para acessar este documento.",
  "preview.nextDocument": "Próximo documento",
  "preview.previousDocument": "Documento anterior",
  "loading": "Carregando",
  "page": "Página"
};
exports.default = _default;
